"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || (function () {
    var ownKeys = function(o) {
        ownKeys = Object.getOwnPropertyNames || function (o) {
            var ar = [];
            for (var k in o) if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
            return ar;
        };
        return ownKeys(o);
    };
    return function (mod) {
        if (mod && mod.__esModule) return mod;
        var result = {};
        if (mod != null) for (var k = ownKeys(mod), i = 0; i < k.length; i++) if (k[i] !== "default") __createBinding(result, mod, k[i]);
        __setModuleDefault(result, mod);
        return result;
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
exports.useFormField = exports.FormLabel = exports.FormField = exports.Form = void 0;
exports.FormControl = FormControl;
exports.FormDescription = FormDescription;
exports.FormItem = FormItem;
exports.FormMessage = FormMessage;
const jsx_runtime_1 = require("react/jsx-runtime");
const react_slot_1 = require("@radix-ui/react-slot");
const React = __importStar(require("react"));
const react_hook_form_1 = require("react-hook-form");
const utils_1 = require("./utils");
const label_1 = require("./label");
const react_i18next_1 = require("react-i18next");
const Form = react_hook_form_1.FormProvider;
exports.Form = Form;
const FormFieldContext = React.createContext({});
const FormField = ({ ...props }) => {
    return ((0, jsx_runtime_1.jsx)(FormFieldContext.Provider, { value: { name: props.name }, children: (0, jsx_runtime_1.jsx)(react_hook_form_1.Controller, { ...props }) }));
};
exports.FormField = FormField;
const useFormField = () => {
    const fieldContext = React.useContext(FormFieldContext);
    const itemContext = React.useContext(FormItemContext);
    const { getFieldState } = (0, react_hook_form_1.useFormContext)();
    const formState = (0, react_hook_form_1.useFormState)({ name: fieldContext.name });
    const fieldState = getFieldState(fieldContext.name, formState);
    if (!fieldContext) {
        throw new Error('useFormField should be used within <FormField>');
    }
    const { id } = itemContext;
    return {
        id,
        name: fieldContext.name,
        formItemId: `${id}-form-item`,
        formDescriptionId: `${id}-form-item-description`,
        formMessageId: `${id}-form-item-message`,
        ...fieldState,
    };
};
exports.useFormField = useFormField;
const FormItemContext = React.createContext({});
function FormItem({ className, ...props }) {
    const id = React.useId();
    return ((0, jsx_runtime_1.jsx)(FormItemContext.Provider, { value: { id }, children: (0, jsx_runtime_1.jsx)("div", { "data-slot": "form-item", className: (0, utils_1.cn)('grid gap-2', className), ...props }) }));
}
const FormLabel = ({ className, required, children, ...props }) => {
    const { error, formItemId } = useFormField();
    return ((0, jsx_runtime_1.jsxs)(label_1.Label, { "data-slot": "form-label", "data-error": !!error, className: (0, utils_1.cn)('data-[error=true]:text-destructive-foreground', className), htmlFor: formItemId, ...props, children: [children, required && (0, jsx_runtime_1.jsx)("span", { className: "text-destructive ml-1", children: "*" })] }));
};
exports.FormLabel = FormLabel;
function FormControl({ ...props }) {
    const { error, formItemId, formDescriptionId, formMessageId } = useFormField();
    return ((0, jsx_runtime_1.jsx)(react_slot_1.Slot, { "data-slot": "form-control", id: formItemId, "aria-describedby": !error ? `${formDescriptionId}` : `${formDescriptionId} ${formMessageId}`, "aria-invalid": !!error, ...props }));
}
function FormDescription({ className, ...props }) {
    const { formDescriptionId } = useFormField();
    return ((0, jsx_runtime_1.jsx)("p", { "data-slot": "form-description", id: formDescriptionId, className: (0, utils_1.cn)('text-muted-foreground text-sm', className), ...props }));
}
function FormMessage({ className, ...props }) {
    var _a;
    const { t } = (0, react_i18next_1.useTranslation)();
    const { error, formMessageId } = useFormField();
    const body = error ? String((_a = error === null || error === void 0 ? void 0 : error.message) !== null && _a !== void 0 ? _a : '') : props.children;
    if (!body) {
        return null;
    }
    return ((0, jsx_runtime_1.jsx)("p", { "data-slot": "form-message", id: formMessageId, className: (0, utils_1.cn)('text-destructive-foreground text-sm', className), ...props, children: t(body) }));
}
